"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var PrivacyTipOutlined_1 = __importDefault(require("@mui/icons-material/PrivacyTipOutlined"));
var BuildOutlined_1 = __importDefault(require("@mui/icons-material/BuildOutlined"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var CookieConsent_1 = require("../CookieConsent");
var SidebarItem_1 = require("./SidebarItem");
var useStyles = (0, makeStyles_1.default)({
    divider: {
        margin: '12px 8px',
    },
});
var CookieConsentSidebarItem = function () {
    var showCookieConsent = (0, react_1.useContext)(CookieConsent_1.CookieConsentContext).showCookieConsent;
    var intl = (0, react_intl_1.useIntl)();
    var classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SidebarItem_1.SidebarItem, { icon: PrivacyTipOutlined_1.default, text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "privacy-policy" }), path: intl.formatMessage({ id: 'privacy-policy-link' }), external: true, dense: true }),
        react_1.default.createElement(SidebarItem_1.RawSidebarItem, { onClick: showCookieConsent, icon: BuildOutlined_1.default, text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "cookie-settings" }), dense: true }),
        react_1.default.createElement(Divider_1.default, { className: classes.divider })));
};
exports.default = CookieConsentSidebarItem;
